import type { FC } from 'react';
import { LoginFooter } from './footer';
import { Header } from './header';

interface Props {
  /** 隐藏header */
  hideFooter?: boolean;
  /** 隐藏footer */
  hideHeader?: boolean;
  /** 隐藏header右上角的所有链接 */
  hideHeaderLink?: boolean;
  /** 是否是团队空间 */
  isJoinTeam?: boolean;
  /** 展示积分规则 */
  showScoreRule?: boolean;
}
/** 包含了header和footer的容器 */
export const Container: FC<Props> = (props) => {
  return (
    <div className="flex justify-between h-full w-full flex-col mx-auto overflow-y-auto">
      <div className="flex-1 flex flex-col">
        {!props.hideHeader && <Header hideAllLink={props.hideHeaderLink} />}
        <div className="flex flex-col items-center flex-1">
          <div className="pt-[15vh] h-md:pt-[5vh] flex-1 sm:w-full w-[400px] flex flex-col">
            {props.children}
          </div>
        </div>
      </div>
      {!props.hideFooter && (
        <LoginFooter isJoinTeam={props.isJoinTeam} showScoreRule={props.showScoreRule} />
      )}
    </div>
  );
};
